$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
PopOver = require 'app/scripts/views/lib/pop-over'

l = require 'app/scripts/lib/localize'
template = require 'app/scripts/views/templates/board_menu_about_this_board'
{ trackUe } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

AboutThisBoardAdminListView = require 'app/scripts/views/board-menu/about-this-board-admin-list-view'
DescriptionView = require 'app/scripts/views/description/description-view'
MemberMiniProfileView = require 'app/scripts/views/member-menu-profile/member-mini-profile-view'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
SearchInputView = require 'app/scripts/views/board-menu/search-input-view'

MAX_FACEPILE_SIZE = 5

module.exports = class BoardMenuAboutThisBoardView extends View
  className: 'board-menu-content-frame'

  events:
    'click .js-change-permissions': 'changePermissions'
    'click .js-fill-board-admin-count': 'openAllMembers'

  initialize: ({ @sidebarView }) ->
    super

    @listenTo @model,
      'change:memberships': @renderDebounced
      'change:prefs.voting': @renderDebounced
      'change:prefs.comments': @renderDebounced
      'change:desc': @renderDebounced

    @descView = @subview DescriptionView, @model,
      maxDescLength: 700
      board: @model
      placeholderKey: @getPlaceHolderText()
      source: 'boardMenuDrawerAboutScreen' # for GAS analytics

    @makeDebouncedMethods 'render'

  getPlaceHolderText: ->
    isTemplate = @model.isTemplate()
    me = Auth.me()
    isAdmin = @model.ownedByMember(me)
    isMember = @model.isMember(me)

    # About this Template description for:
    if isTemplate
      # 1. admin/s and/or member/s of the board
      if isAdmin || isMember
        'about-this-template-description-admin'
      # 2. for visitors who:
        # a. Don't have a Trello account
        # b. Who have a Trello account but aren't members of the template
      else
        'about-this-template-description-visitor'
    else
    # About this Board description JUST for admin/s and member/s
    # Board visitors don't get a description
      'its-your-boards-time-to-shine'

  getViewTitle: ->
    if @model.isTemplate()
      l(['view title', 'about-this-template'])
    else
      l(['view title', 'about-this-board'])

  render: ->
    isLoggedIn = Auth.isLoggedIn()
    me = Auth.me()

    data = {}
    data.isLoggedIn = isLoggedIn
    data.isAdmin = @model.ownedByMember(me)
    data.isNonAdminMember = @model.isMember(me) && !data.isAdmin
    data.isTemplate = @model.isTemplate()

    # Permissions data
    if data.isAdmin
      # what users at all levels can see
      commentLevel = @model.getCommentPerm()
      votingLevel = @model.getPref('voting')
      data.canComment = commentLevel != 'disabled'
      data.canVote = votingLevel != 'disabled'
      data.commentHeader = @getPermissionsLevelHeader(commentLevel)
      data.votingHeader = @getPermissionsLevelHeader(votingLevel)
      data.permissionsHierarchy = @getPermissionsHierarchy(commentLevel, votingLevel)
    else if isLoggedIn
      # what you can see as a Trello member
      data.canComment = @model.canComment(me)
      data.canVote = @model.canVote(me)
    else
      # what logged-out users can see
      data.canComment = @model.getCommentPerm() == 'public'
      data.canVote = @model.getPref('voting') == 'public'

    @$el.html template(data)

    singleAdmin = @model.adminList.length == 1
    if singleAdmin then @renderSingleAdminProfile() else @renderAdminFacepile()
    @$('.about-this-board-multi-admin').toggleClass('hide', singleAdmin)
    @$('.about-this-board-desc').toggleClass('visitor-single-admin', singleAdmin && !data.isAdmin)

    # the outer view is responsible for proving the placeholderkey
    # through the descView, which is now dynamic.
    @descView.placeholderKey = @getPlaceHolderText()
    @appendSubview @descView, @$('.js-fill-atb-desc')
    @renderSearchInputView()

    @

  renderSingleAdminProfile: ->
    admin = @model.adminList.models[0]
    data = admin.toJSON()
    data.showEmail = false
    data.isMe = admin == Auth.me()
    $target = @$('.js-made-by')

    miniProfileSubview = @subview(MemberMiniProfileView, admin)
    @ensureSubview(miniProfileSubview, $target)

  renderAdminFacepile: ->
    $target = @$('.js-made-by-facepile')
    visibleAdmins = @model.orderedVisibleAdmins()
    numAdmins = visibleAdmins.length
    visibleAdminList = visibleAdmins.slice(0, MAX_FACEPILE_SIZE)
    overflowAdminCount = numAdmins - MAX_FACEPILE_SIZE

    if overflowAdminCount > 0
      @$('.js-fill-board-admin-count').text('+' + overflowAdminCount)
      @$('.js-fill-board-admin-count').toggleClass('pile', overflowAdminCount < 100)
      @$('.js-fill-board-admin-count').toggleClass('pile-lg', overflowAdminCount >= 100)
    else
      @$('.js-fill-board-admin-count').text('')

    subviews = for admin in visibleAdminList
      @subview(MemberOnBoardView, admin, { board: @model })

    if $target.length
      @ensureSubviews(subviews, $target)

  openAllMembers: (e) ->
    Util.stop(e)
    # Migrating this event to a screen event in the subview
    trackUe('board sidebar', 'toggles', 'admin list popover', 'from about view', '',
      'by clicking on admin count', { boardId: @model.id, teamId: @model.getOrganization()?.id })

    PopOver.toggle
      elem: @$('.js-fill-board-admin-count')
      maxWidth: 304
      view: AboutThisBoardAdminListView
      options: {
        @model,
        @modelCache
      }

  getPermissionsLevelHeader: (level) ->
    switch level
      when 'members' then 'members-can'
      when 'observers' then 'members-and-observers-can'
      when 'org' then 'team-members-can'
      when 'public' then 'any-trello-user-can'

  getPermissionsHierarchy: (commentLevel, votingLevel) ->
    if commentLevel == votingLevel
      'equal'
    else if commentLevel != 'disabled' && votingLevel == 'disabled'
      'comment'
    else if commentLevel == 'disabled' && votingLevel != 'disabled'
      'voting'
    else
      hierarchy = ['members', 'observers', 'org', 'public']
      if hierarchy.indexOf(commentLevel) < hierarchy.indexOf(votingLevel)
        'comment'
      else
        'voting'

  changePermissions: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'settings'
    return

  showCardFilter: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'filter'
    return

  renderSearchInputView: ->
    # For visitors in template mode, card filter is shown
    container = @$('.js-search-input-view')

    if container.length
      subview = @subview(SearchInputView, @model.filter, {
        showCardFilter: @showCardFilter.bind(@)
      })
      @appendSubview(subview, container)
